import { isEmail } from 'validator';

import { validateForUI } from 'common/helpers/jsonValidator';

const magicLinkSchema = {
  type: 'object',
  properties: {
    email: { type: 'string' }
  },
  required: ['email'],
  additionalProperties: false
};

const loginSchema = {
  type: 'object',
  properties: {
    email: { type: 'string' },
    password: { type: 'string', minLength: 8 }
  },
  required: ['email', 'password'],
  additionalProperties: false
};

const forgotSchema = {
  type: 'object',
  properties: {
    email: { type: 'string' }
  },
  required: ['email'],
  additionalProperties: false
};

const resetSchema = {
  type: 'object',
  properties: {
    password: { type: 'string', minLength: 8 },
    confirmPassword: { type: 'string', minLength: 8 }
  },
  required: ['password', 'confirmPassword'],
  additionalProperties: false
};

export const validateLogin = (params, t) => {
  const errors = validateForUI(
    loginSchema,
    params,
    customValidate(params, t),
    t
  );
  return errors;
};

export const validateMagicLink = (params, t) => {
  const errors = validateForUI(
    magicLinkSchema,
    params,
    customValidate(params, t),
    t
  );
  return errors;
};

export const validateForgotPassword = (params, t) => {
  const errors = validateForUI(
    forgotSchema,
    params,
    customValidate(params, t),
    t
  );
  return errors;
};

export const validateResetPassword = (reset, t) => {
  const errors = validateForUI(
    resetSchema,
    reset,
    customValidateReset(reset, t),
    t
  );
  return errors;
};

const customValidate = (params, t) => {
  const errorArray = [];
  if (params.email && !isEmail(params.email)) {
    const error = {
      field: `email`,
      message: t('general.errorMessages.invalidEmail')
    };
    errorArray.push(error);
  }
  return errorArray;
};

const customValidateReset = (reset, t) => {
  const errorArray = [];
  if (reset.password !== reset.confirmPassword) {
    errorArray.push({
      field: 'confirmPassword',
      message: t('general.errorMessages.confirmPasswordMatch')
    });
  }

  return errorArray;
};
